import { FormattedMessage } from '../../../../../util/reactIntl';
import React, { useState } from 'react';
import css from './WeHaveAnswers.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import classNames from 'classnames';

const questions = [
  {
    question: 'Do clients actually buy?',
    answer:
      'Often—because they only pay for what they love. Private gallery + watermarked previews + simple checkout make buying feel natural.',
  },
  {
    question: 'When do I get paid?',
    answer: 'Right after each client purchase via Stripe—automatic payout to your bank.',
  },
  {
    question: 'How much does Sihmo cost?',
    answer: '10% commission per sale. No monthly fees.',
  },
  {
    question: 'Do I have to upload a certain number of photos?',
    answer: 'No—upload your best. Quality beats quantity.',
  },
  {
    question: 'Am I locked in to Sihmo?',
    answer: 'No exclusivity or shifts. Use Sihmo when it suits you.',
  },
  {
    question: 'Can I set bundles as well as per-photo pricing?',
    answer: 'Yes—set per-photo and bundle prices per session.',
  },
];

function WeHaveAnswers() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = idx => {
    setOpenIndex(prev => (prev === idx ? null : idx));
  };

  return (
    <div className={css.questionWrapper}>
      <div className={css.questionLeft}>
        <div className={css.questionHeading}>
          <span><FormattedMessage id="WeHaveAnswers.questions" /></span>
          <br />
          <FormattedMessage id="WeHaveAnswers.answers" />
        </div>
      </div>
      <div className={css.questionRight}>
        {questions.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={`qa-${i}`} className={css.questionCard}>
              <div
                className={classNames(css.title, isOpen ? css.isActive : '')}
                role="button"
                tabIndex={0}
                onClick={() => toggle(i)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') toggle(i);
                }}
              >
                {item.question}
                {isOpen ? <IconCard type="minus" /> : <IconCard type="plus" />}
              </div>
              {isOpen && <div className={css.answer}>{item.answer}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default WeHaveAnswers;
